import React from "react";
import { Layout, Menu, Flex } from "antd";
import { UserContext } from "../../contexts/user";
import { useLocation, useNavigate } from "react-router-dom";
import menus from "../../constants/menu";
import { Link } from "react-router-dom";
import routes from "../../constants/routes";
// import FullLogo from "../images/new-demo-logo.png";
// import FullLogo from "../images/logo-dark.svg";
// import FullLogo from "../images/demo-logo.png";
// import ZenFullLogo from "../images/zen-commerce.png";
// import TradePortLogo from "../images/tradeport.gif";
import RapidMoneyLogo from "../../images/logo-light.png";
import RapidMoneyIcon  from "../../images/logoIcon.png";
// import themeConfig from "../../config/theme.json";

const { Sider } = Layout;
const getActiveItem = (menus, currentPath) => {
  let activeItem = menus.filter((menuItem) => menuItem.key === currentPath);
  if (activeItem.length > 0) {
    return activeItem[0];
  } else {
    let proccessedItems = menus
      .filter((menuItem) => menuItem.children && menuItem.children?.length > 0)
      .map((menuItem) => getActiveItem(menuItem.children, currentPath))
      .filter((menuItem) => menuItem !== null);
    return proccessedItems?.[0] ?? null;
  }
};

const getUserPermissions = (user) => {
  if (!user || !user.roles || user.roles.length === 0) {
    return [];
  }

  // Extract all permissions from user's roles
  return user.roles.reduce((permissions, role) => {
    if (role.permissions && Array.isArray(role.permissions)) {
      role.permissions.forEach(permission => {
        permissions.push(permission.slug);
      });
    }
    return permissions;
  }, []);
};

const hasPermission = (userPermissions, requiredPermissions) => {
  if (!requiredPermissions || requiredPermissions.length === 0) {
    return true;
  }

  if (requiredPermissions.includes('*')) {
    return true; // Super admin or wildcard permission
  }

  // Check if user has at least one of the required permissions
  return requiredPermissions.some(perm => userPermissions.includes(perm));
};

const getAvailableMenus = (menus, currentPath, userContext) => {
  const userPermissions = getUserPermissions(userContext?.user);

  return menus.filter((menuItem) => {
    if (menuItem.children?.length > 0) {
      menuItem.children = getAvailableMenus(
        menuItem.children,
        currentPath,
        userContext
      );
      return menuItem.children.length > 0;
    } else {
      return hasPermission(userPermissions, menuItem?.requiredPermissions);
    }
  });
};

const processMenus = (menus, currentPath, userContext) => {
  const activeItem = getActiveItem(menus, currentPath);
  const availableMenu = getAvailableMenus(menus, currentPath, userContext);
  // console.log({
  //   activeItem: activeItem,
  //   availableMenu: availableMenu,
  // });
  return {
    activeItem: activeItem,
    availableMenu: availableMenu,
  };
};

 function Sidebar({ closed }) {
  let currentPath = useLocation();
  // const { token } = theme.useToken();
  // const token = theme.getDesignToken(themeConfig);
  const navigate = useNavigate();
  // const menuRef = useRef();

  currentPath = currentPath.pathname.replace(/^\//, "");

  return (
    <UserContext.Consumer>
      {(userContext) => {
        let { activeItem, availableMenu } = processMenus(
          [...menus],
          "/" + currentPath,
          userContext
        );
        return (
          <Sider theme='light' width={250} collapsed={closed} >
            <div className='sidebar-custom-wrap'>
              <div>
                <Link to={routes.DASHBOARD.path}>
                  <Flex
                    // justify={"start"}
                    justify="center"
                    align={closed ? "center" : "flex-start"}
                    style={{
                      paddingBlock: 20,
                      paddingInline: 20,
                      // height: 56,
                      paddingBottom: 0,
                    }}
                  >
                    {/* {isSmallScreen ? ( */}

                    {/* <img
                      src={closed ? IconLogo : FullLogo}
                      className='nav-logo-responsive'
                      style={{ width: "100%" }}
                      alt='Logo'
                    /> */}

                    {/* {closed ?
                      <div style={{ fontWeight: '600', fontSize: '20px' }}>S<span style={{ color: '#d6ab53' }}>S</span></div>
                      :
                      <img
                        src={FullLogo}
                        className='nav-logo-responsive'
                        // style={{ width: "50%" }}
                          style={{ width: "70%",maxHeight:'58px' }}
                        alt='Logo'
                      />
                    }  */}

                    {/* Zen Commerce start */}

                    {closed ?
                      <img
                        src={RapidMoneyIcon }
                        className='nav-logo-responsive'
                        // style={{ width: "50%" }}
                        style={{ width: "60%", }}
                        alt='Logo'
                      />
                      :
                      <img
                        src={RapidMoneyLogo}
                        className='nav-logo-responsive'
                        // style={{ width: "50%" }}
                        style={{ width: "70%", }}
                        alt='Logo'
                      />
                    }
                    {/* Zen Commerce end */}

                    {/* 
                    {closed ? 
                    <div style={{ fontWeight: 600, fontSize: '20px' }}>V<span style={{color:'blue'}}>S</span></div>
                     :
                      <div style={{ fontWeight: 600, fontSize: '20px' }}><span style={{color:'blue'}}>VAPES</span>SHOP</div>
                    } */}


                    {/* ) : null} */}
                  </Flex>
                </Link>
                <Menu
                  mode='inline'
                  selectedKeys={["/" + currentPath]}
                  defaultOpenKeys={activeItem?.openMenuKeys ?? []}
                  items={availableMenu}
                  onSelect={(item) => {
                    return item?.item?.props?.labelOnly === true
                      ? null
                      : navigate(item.key);
                  }}
                />
              </div>
              <div>
                {/* <div className='sidebar-user-card'>
                  <div className='user-details-wrap'>
                    <Avatar
                      style={{
                        backgroundColor: "#cfe2fd",
                        color: "#1f3f7d",
                      }}
                      size='small'
                    >
                      {userContext.user.email.charAt(0)}
                    </Avatar>
                    <div className='user-details'>
                      <div className='user-details-name'>
                        {userContext.user.name}
                      </div>
                      <div className='user-details-email'>
                        {userContext.user.email}
                      </div>
                    </div>
                  </div>
                  <div>
                    <Button size='small' onClick={userContext.logout}>
                      <i className='ri-logout-circle-r-line'></i>
                    </Button>
                  </div>
                </div> */}
              </div>
            </div>
          </Sider>
        );
      }}
    </UserContext.Consumer>
  );
}

export default Sidebar